/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PostApiV1Bank202,
  PostApiV1Bank400,
  PostApiV1Bank401,
  PostApiV1Bank409,
  PostApiV1Bank500,
  PostApiV1BankMutationRequest,
  PostApiV1BankMutationResponse,
} from "../../types/bankRegistroController/PostApiV1Bank.ts";
import { bankSaveResultViewModelSchema } from "../bankSaveResultViewModelSchema.ts";
import { createBankRequestViewModelSchema } from "../createBankRequestViewModelSchema.ts";

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const postApiV1Bank202Schema = z.lazy(
  () => bankSaveResultViewModelSchema,
) as unknown as ToZod<PostApiV1Bank202>;

/**
 * @description (Bad Request) Requisição em formato incorreto ou com dados faltantes.
 */
export const postApiV1Bank400Schema =
  z.any() as unknown as ToZod<PostApiV1Bank400>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const postApiV1Bank401Schema =
  z.any() as unknown as ToZod<PostApiV1Bank401>;

/**
 * @description (Conflict) Há um conflito com os dados existentes.
 */
export const postApiV1Bank409Schema =
  z.any() as unknown as ToZod<PostApiV1Bank409>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const postApiV1Bank500Schema =
  z.any() as unknown as ToZod<PostApiV1Bank500>;

export const postApiV1BankMutationRequestSchema = z.lazy(
  () => createBankRequestViewModelSchema,
) as unknown as ToZod<PostApiV1BankMutationRequest>;

export const postApiV1BankMutationResponseSchema = z.lazy(
  () => postApiV1Bank202Schema,
) as unknown as ToZod<PostApiV1BankMutationResponse>;
